import type { Mission } from '../missions.ts'

export const gsa: Mission = {
  id: "gsa",
  name: "General Services Administration",
  short: "GSA",
  call: "Government",
  kind: "independent",
  url: "https://www.gsa.gov/",
  established: 1949,
  palette: {
    primary: "#005599",
    secondary: "#112d51",
    accent: "#af3639",
  },
  colorSource: {
    kind: "site",
    url: "https://www.gsa.gov/",
  },
  motif: "star",
  mission: {
    text: "GSA is the engine of the American government; driving real estate, acquisition, technology and shared services.",
    url: "https://www.gsa.gov/about-gsa/mission-and-background",
  },
  fact: {
    text: "President Truman established GSA on July 1, 1949, consolidating six agencies, including the National Archives Establishment.",
    url: "https://www.gsa.gov/about-gsa/mission-and-background/our-missions-evolution",
  },
  seal: {
    file: "public/seals/gsa.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-GeneralServicesAdministration-Seal.svg",
  },
  logo: {
    file: "public/logos/gsa.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-GeneralServicesAdministration-Logo.svg",
  },
  identifier: {
    about: "https://www.gsa.gov/about-gsa",
    accessibility: "https://www.gsa.gov/website-information/accessibility-statement",
    foia: "https://www.gsa.gov/reference/freedom-of-information-act-foia",
    noFear: "https://www.gsa.gov/reference/civil-rights-programs/the-no-fear-act",
    oig: "https://www.gsaig.gov/",
    performance: "https://www.gsa.gov/about-gsa/newsroom/budget-and-performance",
    privacy: "https://www.gsa.gov/website-information/website-policies#privacy",
  },
  media: {
    photos: [
      {
        file: "/media/gsa-headquarters.jpg",
        small: "/media/gsa-headquarters-sm.jpg",
        alt: "The limestone GSA headquarters building on a Washington street corner, framed by autumn trees.",
        title: "U.S. General Services Administration Building, 18th Street, Washington, D.C., 2022",
        creator: "Carol M. Highsmith",
        source: "https://www.loc.gov/resource/highsm.72005/",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
      {
        file: "/media/gsa-headquarters-corridor.jpg",
        small: "/media/gsa-headquarters-corridor-sm.jpg",
        alt: "A long marble corridor inside the GSA headquarters, lit by sconces and sunlight from side doorways.",
        title: "Corridor, U.S. General Services Administration Building, Washington, D.C., 2022",
        creator: "Carol M. Highsmith",
        source: "https://www.loc.gov/resource/highsm.72015/",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
